import { render, staticRenderFns } from "./ProposalTaskDeliveryRouterView.vue?vue&type=template&id=54892fd8&"
import script from "./ProposalTaskDeliveryRouterView.vue?vue&type=script&lang=js&"
export * from "./ProposalTaskDeliveryRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports